import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';
import { UserResponse } from '@/features/auth/types';

type UseBusinessLoginOptions = {
  businessId?: number;
};
export const getBusinessesLogin = ({
  businessId,
}: UseBusinessLoginOptions): Promise<UserResponse> => {
  return axios.post(`/business/login`, { businessId });
};

type UseUpdateBusinessLoginOptions = {
  config?: MutationConfig<typeof getBusinessesLogin>;
};

export const useBusinessesLogin = ({ config }: UseUpdateBusinessLoginOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getBusinessesLogin,
  });
};
